import { orange } from '../colors';
export const warningColor = (mode)=>{
    return mode === 'light' ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100]
    } : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800]
    };
};

//# sourceMappingURL=warning.js.map